import axios from 'axios'
import { Message } from 'element-ui'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
const instance = axios.create()
//console.log(instance)
// instance.defaults.baseURL = 'https://hmd.18durensheng.com'
instance.defaults.baseURL = 'https://api.pceapcea.com'

// instance.interceptors.request.use(config => {
//   if (store.state.token) {
//     config.headers['Authorization'] = `Bearer ${store.state.token}`
//   }
//   return config
// })

// instance.interceptors.response.use(response => {
//   if (response.data.data.code == 404) {
//     this.$router.push('/DengL')
//     return
//   }
//   return response
// }, error => {
//   console.log('response error')
//   console.log(error)
// })

export default {
  context: instance,
  get (url, param) {
    return instance({
      url: url,
      method: 'get',
      params: param
    }).then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(res)
      }
    })
  },
  post (url, data, config) {
    return instance.post(url, data, config || {}).then(res => {
    //  console.log(JSON.stringify(res))
      if (res.data.code === 200) {
        return Promise.resolve(res.data.data)
      } else {
        Message({
          message: res.data.msg,
          type: 'error'
        })
        return Promise.reject(res)
      }
    })
  },
  delete (url, data, config) {
    return instance.delete(url, data, config || {}).then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.data)
      } else {
        Message({
          message: res.data.msg,
          type: 'error'
        })
        return Promise.reject(res)
      }
    })
  },
  put (url, data, config) {
    return instance.put(url, data, config || {}).then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.data)
      } else {
        Message({
          message: res.data.msg,
          type: 'error'
        })
        return Promise.reject(res)
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/utils/request.js